<template>
  <div class="news product">
    <banner title="" :img="require('../assets/img/bgtop1.jpg')"/>
    <div class="news-section" v-loading="loading">
      <div class="news-section-content">
        <!-- <div class="content-nav">
          <div
            class="content-nav-btn"
            :class="{'content-nav-active':newstype == 1}"
            @click="newstype = 1"
          >
            <span>公司新闻</span>
          </div>
          <div
            class="content-nav-btn"
            :class="{'content-nav-active':newstype == 2}"
            @click="newstype = 2 "
          >
            <span>行业动态</span>
          </div>
        </div> -->
        <ul>
          <li v-for="(item,index) in resultData" >
            <router-link
                style="color: #000000;"
                class="text-decoration"
                :to="{ name: 'productdetails', query: { cas: item }}"
              >
              {{ item.title }}
              </router-link>
          </li>
          <!-- <li>预付款保函</li>
          <li>工程投标保函</li>
          <li>质量保修保函</li>
          <li>民工工资支付保函</li>
          <li>供货类保函</li> -->
        </ul>
        <div class="content-nav-item">
          <div class="item-list" v-for="(item,index) in resultData" :key="index">
            <div class="item-img" v-lazy:background-image="item.imgUrl"></div>

            <p class="item-list-title">{{item.title}}</p>
            <p class="item-list-content">{{item.content}}</p>
            <div class="item-list-more">
              <router-link
                class="text-decoration"
                :to="{ name: 'productdetails', query: { cas: item }}"
              >
                <img src="../assets/img/sanjiao.png" />
                <span>了解详情</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "news",
  components: {
    Banner
  },
  data() {
    return {
      loading: false,
      newsList: [],
      newstype: 1,
      resultData:[
        {
            "Id": 28,
            "title": "履约担保",
            "imgUrl": require("@/assets/img/product1.jpg"),
            "Type": 1,
            "content": "由保证人为承包商向业主提供的保证承包商履行工程建设合同约定义务的担保。",
            "createTime": "2023-11-29T11:35:37.38"
        },
        {
            "Id": 28,
            "title": "预付款担保",
            "imgUrl": require("@/assets/img/product2.jpg"),
            "Type": 1,
            "content": "业主支付给承包人或供应商合同约定的预付款时，由承包人或供应商向业主提交的担保，保证其按照合同约定正确和合理地为合同目的使用预付款，以及按合同约定配合业主全额扣回所预付的金额，不将 预付款挪作他用。",
            "createTime": "2023-11-29T11:35:37.38"
        },
        {
            "Id": 28,
            "title": "工程投标担保",
            "imgUrl": require("@/assets/img/product3.jpg"),
            "Type": 1,
            "content": "投标担保是指由担保人为投标人向招标人提供的，保证投标人按照招标文件的规定参加招标活动的担保。",
            "createTime": "2023-11-29T11:35:37.38"
        },
        {
            "Id": 28,
            "title": "质量保修保函",
            "imgUrl": require("@/assets/img/product4.jpg"),
            "Type": 1,
            "content": "质量保修担保是保证人为开发商（申请人）在保修期内按《购买合同》、《质量保证书》的约定履行保修义务，而向购主（权益人）提供的担保。若非购主或不可抗力的原因，开发商没有按照上述文件的约定履行保修义务的，购主有权要求保证人代为履行合同义务或赔偿损失。",
            "createTime": "2023-11-29T11:35:37.38"
        },
        {
            "Id": 28,
            "title": "民工工资支付担保",
            "imgUrl": require("@/assets/img/product5.jpg"),
            "Type": 1,
            "content": "民工工资支付担保是指担保人对业主或承包商支付民工工资义务的担保。",
            "createTime": "2023-11-29T11:35:37.38"
        },
        {
            "Id": 28,
            "title": "供货类保函",
            "imgUrl": require("@/assets/img/product6.jpg"),
            "Type": 1,
            "content": "供货类保函指在购销或服务贸易采购合同项下，由供货方向采购方提交的履约保函、预付款保函。",
            "createTime": "2023-11-29T11:35:37.38"
        },
      ],
    };
  },
  methods: {
    loadData() {
      // this.loading = true;
      // this.$http
      //   .get(`News?type=${this.newstype}&num=6`)
      //   .then(response => {
      //     //console.log(response);
      //     this.newsList = response.data;
      //     this.loading = false;
      //     //window.console.log(this.newsList);
      //   })
      //   .catch(function(error) {
      //     window.console.log(error);
      //   });
    }
  },
  mounted() {
    this.loadData();
  },
  watch: {
    newstype(type) {
      window.console.log(type);
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.news {
  width: 100%;
  height: 100%;
  background-color: #f0f0f0;
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    //height: 1600px;

    &-content {
      width: 1240px;
      //height: 1600px;
      margin: 0 auto;
      background-color: #fff;
      border: 1px solid  #e4e4e4;

      .content-nav {
        width: 400px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        //justify-content: center;
        align-items: center;
        position: relative;
        bottom: 30px;
        border: 1px solid  #e4e4e4;

        &-btn {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e4e4e4;
          transition: all 0.2s;
        }

        .content-nav-active {
          background-color: red;
          color: #fff;
        }
      }

      .content-nav-item {
        width: 1070px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        //border: 1px solid blue;

        .item-list {
          width: 330px;
          height: 500px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 10px 10px;
          border: 1px solid #15669e;

          &:hover {
            border: 1px solid #fff;
            box-shadow: 0 0 5px 2px #bfd3e0;
          }
          .item-img {
            width: 300px;
            height: 210px;
            background-color: #cecece;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            background-origin: content-box;
          }

          &-title {
            width: 300px;
            height: 60px;
            color: #15669e;
            font-size: 22px;
            padding: 0 10px;
            margin: 20px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            border-left: 1px solid #15669e;
          }

          &-content {
            width: 273px;
            height: 100px;
            font-size: 14px;
            color: gray;

            // 文本长度处理 begin
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            // 文本长度处理 ending
          }

          &-more {
            width: 273px;
            padding-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 12px;
              height: 12px;
            }
            span {
              color: #e13834;
              padding: 0 5px;
            }
          }
        }
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }
}
.news-section{
  background: #f0f0f0;
  padding-bottom: 80px;
}
.product ul{
  width: 1240px;
  height: 100px;
  li{
    list-style-type: none;
    line-height: 100px;
    float: left;
    width: 200px;
    text-align: center;
    font-size: 20px;
    cursor: pointer;
  }
  li:hover{
    color: #B28147;
  }

}
</style>